import request from '@/config/axios'

export const CatalogPublishLogApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/catalog/publish-log/page', params })
  }
}
